module.exports = __webpack_public_path__ + "static/media/spinner-icon.9209e391.gif";